class NonRacingEventsController {

  constructor(AlertService, EventService) {
    this.AlertService = AlertService;
    this.EventService = EventService;
  }

  $onInit() {
    this.getEvents();
  }

  getEvents() {
    var self = this;
    self.EventService.getNonRacedayEvents(this.raceday.id)
        .then( (events) => self.events = events)
        .catch( (error) => self.AlertService.error("There was a problem getting the list of non-racing events") )
        .finally( );
  }
}
NonRacingEventsController.$inject = ['AlertService', 'EventService'];
export default NonRacingEventsController;
